import AXIOS from "@/axios";

export const connectQuickbooksService = () => {
  return AXIOS.post("/client/v1/quickbooks/connect");
};

export const disconnectQuickbooksService = ({
  refreshToken,
}: {
  refreshToken: string;
}) => {
  return AXIOS.post("/client/v1/quickbooks/disconnect", {
    refresh_token: refreshToken,
  });
};

export const sendQuickbooksData = ({
  code,
  state,
  realmId,
}: {
  code: string;
  state: string;
  realmId: string;
}) => {
  return AXIOS.post<{
    message: string;
    data: {
      id: string;
      realm_id: string;
      expires_in: number;
      token_type: string;
    };
  }>("/client/v1/quickbooks/callback", {
    code,
    state,
    realmId,
  });
};

export const syncQuickbooksData = () => {
  return AXIOS.get<{
    message: string;
    total_received: number;
    total_created: number;
    total_failed: number;
    is_sync: boolean;
  }>("/client/v1/quickbooks/customers");
};
